import React from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import FieldLabelWrapper from '../../../../../../../../../features/components/Form/FieldLabelWrapper'
import MultiSelectBox from '../../../../../../../../../features/components/Form/MultiSelectBox'
import Field from '../../../../../../../../../components/Form/Field'
import Dv360Languages from '../../../../../../../../ReusableFormFields/LanguagesFields/Dv360Languages'
import Dv360CustomAgeRanges from '../../../../../../../reusableFormFields/Dv360CustomAgeRanges'

import { GENDER_OPTION } from '../../../../../../../../ReusableFormFields/GenderFields/fields'
import { CUSTOM_AUDIENCES_EXCLUSION } from '../../../../../../../../ReusableFormFields/Audiences/AudiencesFields/fields'
import { genderOptions } from '../../../../../../../fields'
import { LANGUAGES } from '../../../../../../../../ReusableFormFields/LanguagesFields/fields'

import useDrawerFormStyles from '../../../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const AdvancedAudienceTargetingSection = ({ formik, audiencesIsLoading, formattedAudiences }) => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  const { values, setFieldValue } = formik

  const selectedLanguages = values[LANGUAGES]

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={classnames(drawerFormClasses.sectionTitle, classes.sectionTitle)}>
        {t('Advanced audience targeting')}
      </h3>
      <FieldLabelWrapper label={t('Exclude an audience')} className={classes.subsection}>
        <MultiSelectBox
          placeholder={t('Select an audience...')}
          options={formattedAudiences}
          value={values[CUSTOM_AUDIENCES_EXCLUSION]}
          name={CUSTOM_AUDIENCES_EXCLUSION}
          isLoading={audiencesIsLoading}
          setFieldValue={setFieldValue}
        />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Languages')} className={classes.subsection}>
        <Dv360Languages name={LANGUAGES} setFieldValue={setFieldValue} value={selectedLanguages} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Gender')} className={classes.subsection}>
        <Field
          formik={formik}
          name={GENDER_OPTION}
          placeholder={t('Gender')}
          options={genderOptions}
          isSearchable={false}
        />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Age')} className={classes.subsection}>
        <Dv360CustomAgeRanges formik={formik} />
      </FieldLabelWrapper>
    </section>
  )
}

AdvancedAudienceTargetingSection.propTypes = {
  formik: PropTypes.object.isRequired,
  audiencesIsLoading: PropTypes.bool.isRequired,
  formattedAudiences: PropTypes.array.isRequired
}

export default AdvancedAudienceTargetingSection
